import React from "react";
import { useDisclaimer } from "../../context/DisclaimerContext";
import BaseModal from "../shared/BaseModal";
import Button from "../shared/Button";
import "../../styles/DisclaimerModal.css";

export const DisclaimerModal: React.FC = () => {
  const { showDisclaimer, acceptDisclaimer } = useDisclaimer();

  return (
    <BaseModal
      isOpen={showDisclaimer}
      onClose={() => {}}
      title="Important Notice"
      width="550px"
      showCloseButton={false}
    >
      <div className="dm-content">
        <p>
          Before sending internal links to company documents, make sure that the
          recipient has the necessary access rights. Sending such links to
          external or unauthorized recipients may lead to data protection or
          compliance violations.
        </p>
      </div>

      <div className="dm-footer">
        <Button variant="primary" onClick={acceptDisclaimer}>
          I Understand
        </Button>
      </div>
    </BaseModal>
  );
};

export default DisclaimerModal;
